class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.querySelector('button[type="reset"]').addEventListener(
      'click',
      this.reset.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

 onSummaryClick(event) {
  event.preventDefault();
  const details = event.target.closest('details');

  if (details.hasAttribute('open')) {
    this.close();
  } else {
    this.open(event);


    //  for product recommenddation slider flickity 

    setTimeout(() => {
      var carousel = document.querySelector('.search__recommendation-jtpl.desktop_search_sider'); 
      var numSlides = carousel.querySelectorAll('.menu-item-jtpl').length;
      console.log('hererrerer'+ numSlides);

      
    if (numSlides <= 4) {
      carousel.classList.add('hide-arrows');
    } else {
      carousel.classList.remove('hide-arrows');
    }
      const flkty = new Flickity('.search__recommendation-jtpl.desktop_search_sider', {
        contain: true,
        pageDots: false,
        groupCells:true
      });
      const flktynew = new Flickity('.search__recommendation-jtpl.mobile_search_sider', {
        contain: true,
        pageDots: false,
        groupCells:true
      });

      $(window).on('resize', function() {
        flkty.resize();
         flktynew.resize();
      });
    }, 0);

    
    //  for product recommenddation slider flickity 
    
  }
}

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close();
  }

  open() {
    setScrollbarWidth();
    setHeaderBottomPosition();
    
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('search-modal--open');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close() {
    removeTrapFocus();
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('search-modal--open');
    document.dispatchEvent(new CustomEvent('searchmodal:close'));
  }

  reset(event) {
    event.preventDefault();
    this.querySelector('input[type="search"]').value = '';
  }
}

customElements.define('search-modal', SearchModal);
